<header>
    <img id="join-logo" src="assets/icons/join_logo_dark.svg" alt="Join Logo">
    <span>Kanban Project Management Tool</span>
    <div [ngClass]="[context]">
        <button id="help-btn" (click)="navigateToComponent($event, 'help')">
            <img src="./assets/icons/help.svg" alt="help button">
        </button>
        <button id="user-btn" (click)="toggleNavbar()">{{userInitials}}</button>
    </div>
    <div class="overlay-nav" [ngStyle]="{'display': !navActive ? 'none': 'flex'}" (click)="toggleNavbar()">
        <nav>
            <button class="nav-link mobile" (click)="navigateToComponent($event,'help')">Help</button>
            <button class="nav-link" (click)="navigateToComponent($event,'legal-notice')">Legal Notice</button>
            <button class="nav-link" (click)="navigateToComponent($event,'privacy-policy')">Privacy Policy</button>
            <button class="nav-link" (click)="authService.logOut()">Log out</button>
        </nav>
    </div>

</header>